import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Display,
  FlexDirection,
  Heading3,
  Image,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'

type ImageProps = {
  src: string
  alt: string
  title: string
  paragraph: string
}

export type StepsWithImageProps = {
  steps: ImageProps[]
}

export function StepsWithImage({ steps }: StepsWithImageProps) {
  return (
    <Box
      display={Display.Flex}
      alignItems={[AlignItems.Center, AlignItems.FlexStart]}
      justifyContent={[
        JustifyContent.Center,
        JustifyContent.SpaceBetween,
        null,
        JustifyContent.SpaceEvenly,
      ]}
      flexDirection={[FlexDirection.Column, FlexDirection.Row]}
      wrap
    >
      {steps.map((step) => (
        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          paddingH={1}
          paddingV={2}
          width={['100%', '50%', null, '170px']}
          key={step.title}
        >
          <Image
            style={{ borderRadius: '8px' }}
            height={['200px', null, null, 'auto']}
            fit="cover"
            alt={step.alt}
            src={step.src}
          />
          <Space size={3} />
          <Heading3 size={6}>{step.title}</Heading3>
          <Body2 size={4}>{step.paragraph}</Body2>
          <Space size={2} />
        </Box>
      ))}
    </Box>
  )
}
